import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageRemove"><Path d="M13.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V12.5M16.6135 15.614L18.9885 17.989M18.9885 17.989L21.3635 20.364M18.9885 17.989L21.3635 15.614M18.9885 17.989L16.6135 20.364" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageRemove;
